import checkPartnerCooperationAgreementStatus from "@/shared/router/guards/checkPartnerCooperationAgreementStatus";

export default {
  default: [
    {
      name: "preScans",
      path: "/pre-scans",
      component: () => import("./views/PreScansView.vue"),
      beforeEnter: checkPartnerCooperationAgreementStatus
    }
  ]
};
